export class WorkflowStageReferences {
    workflowStageUid: string;
    workflowStageEntityReferences: WorkflowStageEntityReference[];
    workflowStageRuleReferences: any[];
    workflowStageReportReferences: WorkflowStageReportReferences[];

    constructor(data: any) {
        this.workflowStageUid = data?.workflowStageUid;
        this.workflowStageEntityReferences = data?.workflowStageEntityReferences;
        this.workflowStageRuleReferences = data?.workflowStageRuleReferences;
        this.workflowStageReportReferences = data?.workflowStageReportReferences;
    }
}

export interface WorkflowStageEntityReference {
    entityUid: string;
    readOnly: boolean;
    show: boolean;
}

export interface WorkflowStageReportReferences {
    outboundChainId: string;
    outboundChainName: string;
    restApiName: string;
}
